module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNzAuMTQ2IiBoZWlnaHQ9IjIyNC43ODkiIHZpZXdCb3g9IjAgMCAyNzAuMTQ2IDIyNC43ODkiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzU5NSIgZGF0YS1uYW1lPSLjg5HjgrkgMzU5NSIgZD0iTS0yODUuODgsMjQ5LjAzM3YtMTIyLjRMLTE1LjczNSwyNC4yNDR2MTIyLjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyODUuODgxIC0yNC4yNDQpIiBmaWxsPSJyZWQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/red_270.svg
// module id = YkUL
// module chunks = 0